// CookieBanner.js

import React, { useEffect, useState } from "react";
import { getConsent, setConsent, hasUserConsented } from "./cookieUtils";

const CookieBanner2 = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showCustomizeModal, setShowCustomizeModal] = useState(false);
  const [customConsent, setCustomConsent] = useState({
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    if (!hasUserConsented()) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = {
      technical: true,
      analytics: true,
      marketing: true,
    };
    setConsent(consent);
    setShowBanner(false);
  };

  const handleRefuseAll = () => {
    const consent = {
      technical: true,
      analytics: false,
      marketing: false,
    };
    setConsent(consent);
    setShowBanner(false);
  };

  const handleSavePreferences = () => {
    const consent = {
      technical: true,
      analytics: customConsent.analytics,
      marketing: customConsent.marketing,
    };
    setConsent(consent);
    setShowBanner(false);
    setShowCustomizeModal(false);
  };  


  if (!showBanner) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {!showCustomizeModal ? (
          <>
        <h2>Abbiamo a cuore la tua privacy</h2>
        <p>
          Ultimo aggiornamento: 29/07/2025.
        </p>
        <p>
          Il presente sito web rispetta la privacy dei visitatori e si impegna a proteggere i dati personali
          secondo quanto previsto dal Regolamento Europeo 2016/679 (GDPR).
        </p>
        <p>
          Il titolare del trattamento dei dati è: <br/>
          Maria Federica Simoni <br/>
          Email: federica.simoni@hotmail.it

        </p>
        <p>
          Durante la navigazione, questo sito può raccogliere automaticamente alcune informazioni, tra cui: <br />
            •	Indirizzo IP <br />
            •	Tipo di browser e parametri del dispositivo usato <br />
            •	Nome dell’ISP <br />
            •	Data e orario di visita <br />
            •	Pagine visitate <br />
          Questi dati vengono raccolti in forma anonima e aggregata a fini statistici e di sicurezza.
        </p>
        <p>
            Questo sito utilizza cookie tecnici, analitici e di profilazione, inclusi quelli di terze parti (come Google AdSense).
            I cookie sono piccoli file di testo salvati nel tuo dispositivo per migliorare l’esperienza di navigazione e mostrare annunci pertinenti.
            Puoi gestire o disabilitare i cookie direttamente dal tuo browser. Per saperne di più visita: <br />
            👉 <a href="https://www.aboutcookies.org" target="_blank" rel="noreferrer">www.aboutcookies.org</a>
        </p>
        <p>
            Questo sito utilizza Google AdSense, un servizio di pubblicità fornito da Google LLC.
            AdSense utilizza cookie per mostrare annunci pubblicitari basati sugli interessi degli utenti.
            I dati raccolti da Google sono gestiti secondo la Privacy Policy di Google.
            Gli utenti possono disattivare la pubblicità personalizzata visitando:  <br />
            👉 <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">https://adssettings.google.com</a>
        </p>
        <p>
            I dati raccolti vengono trattati per: <br/>
            •	Migliorare la navigazione del sito <br/>
            •	Analisi statistica anonima <br/>
            •	Visualizzazione di annunci pubblicitari 
        </p>
        <p>
        Il trattamento avviene in forma automatizzata, nel rispetto delle norme di sicurezza previste dalla legge. I dati non vengono mai ceduti a terzi,
        salvo obblighi di legge o necessità tecniche (es. hosting o Google AdSense).
        </p>
        <p>
        Hai diritto di: <br/>
        •	Accedere ai tuoi dati <br/>
        •	Chiedere la modifica o cancellazione <br/>
        •	Limitare o opporti al trattamento <br/>
        Puoi esercitare i tuoi diritti scrivendo a: <br/>
        📧 federica.simoni@hotmail.it
        </p>
        <p>
        Ci riserviamo il diritto di aggiornare questa Privacy Policy in qualsiasi momento. Ti invitiamo a consultarla periodicamente.
        </p>
        <div style={styles.buttons}>
          <button onClick={handleAcceptAll}>Accetta tutti</button>
          <button onClick={handleRefuseAll}>Rifiuta</button>
          <button onClick={() => setShowCustomizeModal(true)}>Personalizza</button>
        </div>
        </>
        ):(
         <div>
            <h3>Personalizza le tue preferenze</h3>
            <label>
              <input
                type="checkbox"
                checked={customConsent.analytics}
                onChange={(e) =>
                  setCustomConsent({
                    ...customConsent,
                    analytics: e.target.checked,
                  })
                }
              />
              <strong style={{ marginLeft: "8px" }}>Cookie Analitici</strong>
                <p style={{ marginLeft: "26px", marginTop: "5px" }}>
                  Utilizzati per raccogliere dati in forma anonima sulle visite e sul comportamento degli utenti.
                  Ci aiutano a migliorare i contenuti e l'esperienza del sito.
                </p>
            </label>
            <br />
            <label>
              <input
                type="checkbox"
                checked={customConsent.marketing}
                onChange={(e) =>
                  setCustomConsent({
                    ...customConsent,
                    marketing: e.target.checked,
                  })
                }
              />
                <strong style={{ marginLeft: "8px" }}>Cookie di Marketing</strong>
                <p style={{ marginLeft: "26px", marginTop: "5px" }}>
                  Servono per mostrarti annunci pertinenti su altri siti e per misurare l'efficacia delle campagne pubblicitarie.
                </p>
            </label>
            <div style={styles.buttons}>
              <button onClick={handleSavePreferences}>Salva preferenze</button>
              <button onClick={() => setShowCustomizeModal(false)}>Annulla</button>
            </div>
          </div>
        )} 
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "30px",
    maxWidth: "800px",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
    textAlign: "left",
    overflowY: "auto",
    maxHeight: "50vh"
  },
 
  buttons: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "space-between",
    gap: "10px"
  },
};

export default CookieBanner2;
